module.exports = __webpack_public_path__ + "img/headPortrait.fb05609f.png";